import React, {type Node} from 'react'
import IconContainer from 'components/SideBar/ui/IconContainer'
import styles from './index.scss'

type Props = $ReadOnly<{
  children: Node,
  id?: string,
  renderIcon: () => Node,
  renderTitle: () => Node,
}>

function Section({children, id, renderIcon, renderTitle}: Props) {
  return (
    <div className={styles.section} id={id}>
      <div className={styles.title}>
        <IconContainer size="md">
          {renderIcon()}
        </IconContainer>
        <div className={styles.label}>
          {renderTitle()}
        </div>
      </div>
      {children}
    </div>
  )
}

Section.defaultProps = {
  id: null,
}

export default Section
